import { getJson } from 'shared-base';
import { holodeckStateDefaults as d } from '../data/data.holodeck';

const holodeckStateCache = getJson('holodeckState');

const {
  areGridLinesVisible = d.areGridLinesVisible,
  gridLinesColor = d.gridLinesColor,
  gridLinesOpacity = d.gridLinesOpacity,
  lightColor = d.lightColor,
  lightIntensity = d.lightIntensity,
  isEditorDarkMode = d.isEditorDarkMode,
  backgroundColor = d.backgroundColor,
  backgroundIntensity = d.backgroundIntensity,
  backdropEnabled = d.backdropEnabled,
  backdropGrainIntensity = d.backdropGrainIntensity,
  backdropId = d.backdropId,
  cameraLock,
  camera,
  shader = 'Standard',
} = holodeckStateCache ?? {};

export const holodeckState: IHolodeckState = {
  areGridLinesVisible,
  gridLinesColor,
  gridLinesOpacity,
  isEditorDarkMode,
  lightColor,
  lightIntensity,
  backgroundColor,
  backgroundIntensity,
  backdropGrainIntensity,
  shader,
  backdropEnabled,
  backdropId,
  cameraLock,
  camera,
};
